import {
    GET_USED_VOUCHERS,
    GET_UNUSED_VOUCHERS,
    GET_ALL_VOUCHERS,
    VOUCHERS_FAILED,
} from "../actions/types";

const initialState = {
    voucher: null,
    vouchers: [],
    userVouchers: [],
    usedVouchers: [],
    unUsedVouchers: [],
    loading: true,
};

export default function vouchersReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_ALL_VOUCHERS:
            return {
                ...state,
                vouchers: payload,
                loading: false,
            };
        case GET_USED_VOUCHERS:
            return {
                ...state,
                usedVouchers: payload,
                loading: false,
            };
        case GET_UNUSED_VOUCHERS:
            return {
                ...state,
                unUsedVouchers: payload,
                loading: false,
            };

        case VOUCHERS_FAILED:
            return {
                ...state,
                vouchers: [],
            };

        default:
            return state;
    }
}
